import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import WelcomePage from './pages/WelcomePage'
import ActivationPage from './pages/ActivationPage'
import QueryPage from './pages/QueryPage'
import ThirdPartyPrivacyPage from './pages/ThirdPartyPrivacyPage'

function App() {
  return (
    <Router>
      <Routes>
        {/* 欢迎/提示页面 - URL: https://h.blet.cc/{braceletId} */}
        <Route path="/:braceletId" element={<WelcomePage />} />

        {/* 手环激活页面 - URL: https://h.blet.cc/activate/{braceletId} */}
        <Route path="/activate/:braceletId" element={<ActivationPage />} />

        {/* 手环查询页面 - URL: https://h.blet.cc/query/{braceletId} */}
        <Route path="/query/:braceletId" element={<QueryPage />} />

        {/* 第三方查看隐私协议 */}
        <Route path="/privacy-viewer" element={<ThirdPartyPrivacyPage />} />

        {/* 管理后台 - 后续实现 */}
        <Route path="/admin/*" element={<div className="p-4">管理后台</div>} />
      </Routes>
    </Router>
  )
}

export default App
